import React from "react";
import { Users, Headphones, LifeBuoy, ShieldCheck, Home, Egg, HeartPulse, Truck, Syringe, Award } from "lucide-react";
import { useContent } from "../context/ContentContext";

const iconMap = { Users, Headphones, LifeBuoy, ShieldCheck, Home, Egg, HeartPulse, Truck, Syringe, Award };

const Principles = () => {
  const { content } = useContent();
  const principles = content.principles || [];

  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="inline-block text-xs font-semibold tracking-[0.25em] text-[#b91c1c] uppercase mb-3">— İlkelerimiz</span>
          <h2 className="text-3xl md:text-4xl font-black text-[#b91c1c] leading-tight">Neden Aktav Yarka?</h2>
          <p className="text-slate-600 mt-3">Satış öncesinden sonrasına kadar yanınızdayız. Profesyonel hizmet anlayışımızla sektörün standartlarını belirliyoruz.</p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {principles.map((p, idx) => {
            const Icon = iconMap[p.icon] || ShieldCheck;
            return (
              <div key={idx} className="relative bg-white rounded-2xl p-7 border border-slate-200 hover:border-[#b91c1c] hover:shadow-xl transition-all group overflow-hidden">
                <div className="absolute -right-6 -top-6 w-24 h-24 rounded-full bg-[#b91c1c]/5 group-hover:bg-[#b91c1c]/10 transition-colors" />
                <div className="relative">
                  <div className="w-12 h-12 rounded-lg bg-[#b91c1c] flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                    <Icon className="w-6 h-6 text-white" />
                  </div>
                  <div className="text-[#b91c1c]/15 font-black text-5xl absolute -top-2 right-0 select-none">0{idx + 1}</div>
                  <h3 className="text-lg font-bold text-[#b91c1c] mb-2 mt-2">{p.title}</h3>
                  <p className="text-sm text-slate-600 leading-relaxed">{p.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Principles;
